import { table } from "../models.model";

export const AIRAC_CONFIG: table = {
  columnas: [
    'Plazos',
    '0-15 días',
    '16-30 días',
    '31-60 días',
    '61-90 días',
    '91-181 días',
    '181-360 días',
    '1-2 años',
    '2-3 años',
    '3-4 años',
    '4-5 años',
    'Más 5 años',
    'Vencimiento indeterminado',
    'Total',
  ],
  filas: [
    {
      type: 'titulo',
      id: 'TITULO_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: 'Activo y contingencias'
    },{
      type: 'valorComp',
      id: 'DISPONIBILIDADES_01',
      codigo: '',
      valorComparar: 'disponibilidades_01',
      bandas: [1,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: 'Disponibilidades',
      visible: true
    },{
      type: 'subtotal',
      id: 'CARTERA_01',
      codigo: '',
      valorComparar: 'carteracreditos_01',
      bandas: [1,1,1,1,1,1,1,1,1,1,1,1],
      descripcion: 'Cartera de créditos',
      visible: true,
      sumar: ['CEROS_01','CUOTAS_01','CUOTAS_02','CUOTAS_03'],
      expandible: true,
      expandido: true,
    },{
      type: 'ceros',
      id: 'CEROS_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: '\tCompra de titulos con pacto de reventa',
      visible: true,
    },{
      type: 'valorComp',
      id: 'CUOTAS_01',
      codigo: '',
      valorComparar: 'cartera_01',
      bandas: [1,1,1,1,1,1,1,1,1,1,1,0],
      descripcion: '\tCartera clasificada A y B',
      visible: true,
      ingresoManual: true,
    },{
      type: 'valorComp',
      id: 'CUOTAS_02',
      codigo: '',
      valorComparar: 'cartera_02',
      bandas: [1,1,1,1,1,1,1,1,1,1,1,0],
      descripcion: '\tCartera clasificada C',
      visible: true,
      ingresoManual: true,
    },{
      type: 'valorComp',
      id: 'CUOTAS_03',
      codigo: '',
      valorComparar: 'cartera_03',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: '\tCartera clasificada D1, D2 y E',
      visible: true,
      ingresoManual: true,
    },{
      type: 'subtotal',
      id: 'INVERSIONES',
      codigo: '',
      valorComparar: 'cuotas_4',
      bandas: [1,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: 'Inversiones',
      sumar: ['INVERSIONES_01','INVERSIONES_02','INVERSIONES_03','INVERSIONES_04','INVERSIONES_05'],
      visible: true,
      expandible: true,
      expandido: true
    },{
      type: 'valorComp',
      id: 'INVERSIONES_01',
      codigo: '',
      valorComparar: 'inversiones_01',
      bandas: [1,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: 'Inversiones a negociar (a valor razonable con cambios en los resultados)',
      visible: true,
    },{
      type: 'valorComp',
      id: 'INVERSIONES_02',
      codigo: '',
      valorComparar: 'inversiones_02',
      bandas: [1,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: 'Inversiones disponible para la venta (a valor razonable con cambios en el patrimonio)',
      visible: true,
    },{
      type: 'valorComp',
      id: 'INVERSIONES_03',
      codigo: '',
      valorComparar: 'inversiones_03',
      bandas: [1,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: 'Inversiones mantenidas hasta el vencimiento (inversiones a costo amortizado)',
      visible: true,
    },{
      type: 'valorComp',
      id: 'INVERSIONES_04',
      codigo: '',
      valorComparar: 'valores_01',
      bandas: [1,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: 'Otros valores en instrumentos de deuda',
      visible: true,
    },{
      type: 'valorComp',
      id: 'INVERSIONES_05',
      codigo: '',
      valorComparar: 'valores_02',
      bandas: [1,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: 'Valores de disponibilidad restringida',
      visible: true,
    },{
      type: 'valorComp',
      id: 'CUENTAS_01',
      codigo: '',
      valorComparar: 'cuentascobrar_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Cuentas por cobrar',
      visible: true,
    },{
      type: 'valorComp',
      id: 'DISPONIBILIDADES_02',
      codigo: '',
      valorComparar: 'activosfijos_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Activos fijos',
      visible: true,
    },{
      type: 'valorComp',
      id: 'DISPONIBILIDADES_03',
      codigo: '',
      valorComparar: 'participaciones_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Participaciones en otras sociedades',
      visible: true,
    },{
      type: 'valorComp',
      id: 'DISPONIBILIDADES_04',
      codigo: '',
      valorComparar: 'otrosactivos_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Otros activos no financieros',
      visible: true,
    },{
      type: 'valorComp',
      id: 'DISPONIBILIDADES_05',
      codigo: '',
      valorComparar: 'contingencias_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Contingencias deudoras',
      visible: true,
    },{
      type: 'valorComp',
      id: 'DISPONIBILIDADES_06',
      codigo: '',
      valorComparar: 'provisiones_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Provisiones por activos y contingencias',
      visible: true,
    },{
      type: 'valorComp',
      id: 'DISPONIBILIDADES_07',
      codigo: '',
      valorComparar: 'otrosactivos_02',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Otros activos financieros',
      visible: true,
    },{
      type: 'subtotal',
      id: 'SUBTOTAL_01',
      codigo: '',
      bandas: [1,1,1,1,1,1,1,1,1,1,1,1],
      sumar: [
        'DISPONIBILIDADES_01',
        'CARTERA_01',
        'CUOTAS_04',
        'CUENTAS_01',
        'DISPONIBILIDADES_02',
        'DISPONIBILIDADES_03',
        'DISPONIBILIDADES_04',
        'DISPONIBILIDADES_05',
        'DISPONIBILIDADES_06',
        'DISPONIBILIDADES_07'
      ],
      descripcion: 'Total de activos y contingencias',
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_01',
      codigo: '',
      bandas: [1,1,1,1,1,1,1,1,1,1,1,1],
      descripcion: 'Plazo promedio',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 15},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 30},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 15},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 30},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 60},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 60},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 90},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 4,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 90},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 180},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 5,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 180},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 360},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 6,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 720},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 7,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 720},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 1080},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 8,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 1080},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 1440},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 9,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 1440},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 1800},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 10,
          expresion: [
            {tipo: 'numero', valor: 1800},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 11,
          expresion: [
            {tipo: 'numero', valor: 1800},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        }   
      ],
      decimales: 2,
      suma: true,
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_02',
      codigo: '',
      bandas: [1,1,1,1,1,1,1,1,1,1,1,1],
      descripcion: 'Total activos y contingencias ponderados por plazo',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        },{
          banda: 4,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        },{
          banda: 5,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        },{
          banda: 6,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        },{
          banda: 7,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        },{
          banda: 8,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        },{
          banda: 9,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        },{
          banda: 10,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        },{
          banda: 11,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_01'}
          ]
        }   
      ],
      decimales: 2,
      suma: true,
      visible: true,
    },{
      type: 'blank',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,0]
    },{
      type: 'titulo',
      id: 'TITULO_02',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: 'Pasivos pratimonio y contigencias'
    },{
      type: 'valorComp',
      id: 'FONDEO_01',
      codigo: '',
      valorComparar: 'fondos_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: 'Fondos interbancarios recibidos',
      visible: true
    },{
      type: 'valorComp',
      id: 'VOLATILIDAD_01',
      codigo: '',
      valorComparar: 'depositos_01',
      bandas: [1,1,1,1,0,0,0,0,0,0,0,0],
      descripcion: 'Porción volatil de depósitos del público',
      visible: true
    },{
      type: 'valorComp',
      id: 'DEPOSITOS_02',
      codigo: '',
      valorComparar: 'depositos_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Porción permanente de depósitos del público',
      visible: true
    },{
      type: 'valorComp',
      id: 'DEPOSITOS_01',
      codigo: '',
      valorComparar: 'depositos_02',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Depósitos y valores del público restringidos',
      visible: true
    },{
      type: 'valorComp',
      id: 'DEPOSITOS_03',
      codigo: '',
      valorComparar: 'depositos_03',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,0],
      descripcion: 'Cargos por pagar por depósitos y valores en poder del público',
      visible: true
    },{
      type: 'valorComp',
      id: 'FINANCIAMIENTO_01',
      codigo: '',
      valorComparar: 'financiamientos_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Financiamientos obtenidos',
      visible: true
    },{
      type: 'valorComp',
      id: 'FINANCIERO_01',
      codigo: '',
      valorComparar: 'obligaciones_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Obligaciones financieras',
      visible: true
    },{
      type: 'valorComp',
      id: 'ACREEDORES_01',
      codigo: '',
      valorComparar: 'acreedores_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Acreedores y provisiones diversos',
      visible: true
    },{
      type: 'valorComp',
      id: 'PASIVOS_01',
      codigo: '',
      valorComparar: 'pasivos_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Otros pasivos no financieros',
      visible: true
    },{
      type: 'valorComp',
      id: 'FONDOS_01',
      codigo: '',
      valorComparar: 'fondos_02',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Fondos en administración',
      visible: true
    },{
      type: 'valorComp',
      id: 'OBLIGACIONES_01',
      codigo: '',
      valorComparar: 'obligaciones_02',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Obligaciones subordinadas',
      visible: true
    },{
      type: 'valorComp',
      id: 'OBLIGACIONES_02',
      codigo: '',
      valorComparar: 'obligaciones_03',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Obligaciones convertibles en capital',
      visible: true
    },{
      type: 'valorComp',
      id: 'PATRIMONIO_01',
      codigo: '',
      valorComparar: 'patrimonio_01',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Patrimonio',
      visible: true
    },{
      type: 'valorComp',
      id: 'CONTINGENCIAS_01',
      codigo: '',
      valorComparar: 'contingencias_02',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Contingencias acreedoras',
      visible: true
    },{
      type: 'valorComp',
      id: 'ACREEDORAS_01',
      codigo: '',
      valorComparar: 'provisiones_02',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Provisiones por contingencias acreedoras',
      visible: true
    },{
      type: 'valorComp',
      id: 'PASIVOS_02',
      codigo: '',
      valorComparar: 'pasivos_02',
      bandas: [0,0,0,0,0,0,0,0,0,0,0,1],
      descripcion: 'Otros pasivos financieros',
      visible: true
    },{
      type: 'subtotal',
      id: 'SUBTOTAL_02',
      codigo: '',
      bandas: [1,1,1,1,1,1,1,1,1,1,1,1],
      sumar: [
        'FONDEO_01',
        'VOLATILIDAD_01',
        'DEPOSITOS_02',
        'DEPOSITOS_01',
        'DEPOSITOS_03',
        'FINANCIAMIENTO_01',
        'FINANCIERO_01',
        'ACREEDORES_01',
        'PASIVOS_01',
        'FONDOS_01',
        'OBLIGACIONES_01',
        'OBLIGACIONES_02',
        'PATRIMONIO_01',
        'CONTINGENCIAS_01',
        'ACREEDORAS_01',
        'PASIVOS_02',
      ],
      descripcion: 'Total de pasivos patrimonio y contingencias',
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_03',
      codigo: '',
      bandas: [1,1,1,1,1,1,1,1,1,1,1,1],
      descripcion: 'Plazo promedio',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 15},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 30},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 15},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 30},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 60},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 60},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 90},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 4,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 90},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 180},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 5,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 180},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 360},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 6,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 720},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 7,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 720},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 1080},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 8,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 1080},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 1440},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 9,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'numero', valor: 1440},
            {tipo: 'operador', valor: '+'},
            {tipo: 'numero', valor: 1800},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 2},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 10,
          expresion: [
            {tipo: 'numero', valor: 1800},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        },{
          banda: 11,
          expresion: [
            {tipo: 'numero', valor: 1800},
            {tipo: 'operador', valor: '/'},
            {tipo: 'numero', valor: 360},
            {tipo: 'operador', valor: '*'},
            {tipo: 'numero', valor: 12},
          ]
        }   
      ],
      decimales: 2,
      suma: true,
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_04',
      codigo: '',
      bandas: [1,1,1,1,1,1,1,1,1,1,1,1],
      descripcion: 'Total pasivos patrimonio y contingencia ponderados por plazo',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        },{
          banda: 4,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        },{
          banda: 5,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        },{
          banda: 6,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        },{
          banda: 7,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        },{
          banda: 8,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        },{
          banda: 9,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        },{
          banda: 10,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        },{
          banda: 11,
          expresion: [
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'operador', valor: '/'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02.total'},
            {tipo: 'parentesis', valor: ')'},
            {tipo: 'operador', valor: '*'},
            {tipo: 'cuenta', valor: 'OPERACION_03'}
          ]
        }   
      ],
      decimales: 0,
      suma: true,
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_05',
      codigo: '',
      bandas: [1,1,1,1,1,1,1,1,1,1,1,1],
      descripcion: 'Brecha o gap de vencimiento',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        },{
          banda: 4,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        },{
          banda: 5,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        },{
          banda: 6,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        },{
          banda: 7,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        },{
          banda: 8,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        },{
          banda: 9,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        },{
          banda: 10,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        },{
          banda: 11,
          expresion: [
            {tipo: 'cuenta', valor: 'OPERACION_02'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'OPERACION_04'},
          ]
        }   
      ],
      decimales: 2,
      suma: true,
      visible: true,
    },{
      type: 'operacion',
      id: 'OPERACION_06',
      codigo: '',
      bandas: [1,1,1,1,1,1,1,1,1,1,1,1],
      descripcion: 'Posición de liquidez acumulada',
      operaciones: [
        {
          banda: 0,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 1,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 2,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 3,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 4,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 5,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 6,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 7,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 8,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 9,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 10,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        },{
          banda: 11,
          expresion: [
            {tipo: 'cuenta', valor: 'acumulado'},
            {tipo: 'operador', valor: '+'},
            {tipo: 'parentesis', valor: '('},
            {tipo: 'cuenta', valor: 'SUBTOTAL_01'},
            {tipo: 'operador', valor: '-'},
            {tipo: 'cuenta', valor: 'SUBTOTAL_02'},
            {tipo: 'parentesis', valor: ')'},
          ]
        }   
      ],
      decimales: 0,
      suma: true,
      visible: true,
    }
  ]
}